// src/pages/NotFound.tsx
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <section className="section-container text-center">
          <div className="glass rounded-lg p-8 md:p-12 max-w-2xl mx-auto">
            <h1 className="text-5xl md:text-7xl font-bold text-barber-900 mb-4">404</h1>
            <h2 className="text-2xl md:text-3xl font-semibold mb-6 text-muted-foreground">
              Page Not Found
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Oops! Looks like you’ve wandered off the path. Let’s get you back to the barber chair.
            </p>
            <Button
              asChild
              className="bg-barber-900 text-white px-6 py-3 rounded-full font-medium transition-all duration-300 hover:shadow-md hover:scale-105"
            >
              <a href="/" className="flex items-center space-x-2">
                <Home size={20} />
                <span>Back to Home</span>
              </a>
            </Button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;